import React, { useEffect, useState } from "react";
import {
  calculateTimeDifference,
  formatDate2,
  formatDate3,
  formatDateToFullDateString,
  getTimeInAMPMFormat,
  isDateMatch,
} from "../../validation";
import moment from "moment";
import { companyID } from "../../auth";
import api from "../../api/axios";
import Loader from "../Loader";

const AttendenceModelPopup = ({
  employeeAttendanceData,
  isToday,
  setReRenderAttandanceData,
}) => {
  const [employeeAttendanceDetail, setEmployeeAttendanceDetail] = useState({});
  const [activityDetail, setActivityDetail] = useState([]);
  const [attendanceInfo, setAttendanceInfo] = useState({});
  const [loadingStates, setLoadingStates] = useState({
    approve: false,
    revoke: false,
    fullDay: false,
    halfDay: false,
    absent: false,
  });

  const formatUtcToLocalTime = (value, format) => {
    if (!value) {
      return "";
    }
    const parsed = moment.utc(value);
    if (parsed.isValid()) {
      return parsed.local().format(format);
    }
    const fallback = moment(value);
    if (!fallback.isValid()) {
      return "";
    }
    return fallback.local().format(format);
  };


  let formattedTotalHours = 0;

  const employeeAttendanceHandler = async (date, employee_id) => {
    try {
      if (!employee_id || !date) {
        return;
      }
      const response = await api.get(
        `api/attendance/attendace/${employee_id}/${date}`
      );
      if (response?.data?.result) {
        setEmployeeAttendanceDetail(response?.data?.result[0]);
      }
      if (response?.data?.results) {
        setActivityDetail(response?.data?.results);
      } 
      setAttendanceInfo({
        attendance_approval_applied : response?.data?.attendance_approval_applied,
        leave_applied : response?.data.leave_applied
      })
    } catch (err) {
      console.log(err);
    }
  };

   const [isApproveAttendance, setIsApproveAttendance] = useState(false);
  const handleCanApproveAttendance = async (employee_id) => {
    try {
      const response = await api.get(`employee_allowance?employee_id=${employee_id ?? localStorage.getItem("employeeID")}`);
      if (response?.data?.result[0]?.approval_not_allow == 0) {
        setIsApproveAttendance(true);
      }
      else {
        setIsApproveAttendance(false);
      }
    }
    catch (error) {
      console.error("Error checking leave permission:", error);
    }
  }
  
  useEffect(() => {
    employeeAttendanceHandler(
      employeeAttendanceData?.date,
      employeeAttendanceData?.employeeId
    );
    handleCanApproveAttendance(employeeAttendanceData?.employeeId)
    
  }, [employeeAttendanceData]);

  const handleFullAttendanceApproval = (
    date,
    employee_id,
    employeeName,
    marked_id
  ) => {
    const company_id = companyID();
    const approved_by = localStorage.getItem("employeeID");

    if (marked_id === undefined) {
      setLoadingStates((prev) => ({ ...prev, approve: true }));
      api
        .post(
          `api/attendance/attendace/${employee_id}/${date}/${company_id}/${approved_by}`
        )
        .then((res) => {
          employeeAttendanceHandler(date, employee_id);
          setReRenderAttandanceData(true);
          setLoadingStates((prev) => ({ ...prev, approve: false }));
        })
        .catch((err) => {
          console.log(err);
          setLoadingStates((prev) => ({ ...prev, approve: false }));
        });
    } else if (marked_id == 1 && employee_id && date) {
      setLoadingStates((prev) => ({ ...prev, revoke: true }));
      api
        .put(
          `api/attendance/attendace-revoke/${employee_id}/${date}/${company_id}/${approved_by}`
        )
        .then((res) => {
          setReRenderAttandanceData(true);
          employeeAttendanceHandler(date, employee_id);
          setLoadingStates((prev) => ({ ...prev, revoke: false }));
        })
        .catch((err) => {
          console.log(err);
          setLoadingStates((prev) => ({ ...prev, revoke: false }));
        });
    } else {
      setLoadingStates((prev) => ({ ...prev, approve: true }));
      api
        .put(
          `api/attendance/attendace/${employee_id}/${date}/${company_id}/${approved_by}`
        )
        .then((res) => {
          setReRenderAttandanceData(true);
          employeeAttendanceHandler(date, employee_id);
          setLoadingStates((prev) => ({ ...prev, approve: false }));
        })
        .catch((err) => {
          console.log(err);
          setLoadingStates((prev) => ({ ...prev, approve: false }));
        });
    }
  };

  function convertToTimeFormat(totalHours, overtime) {
    if (totalHours == null || totalHours === "") {
      return 0;
    }
    const hoursNum = Number(totalHours);
    if (isNaN(hoursNum)) {
      return 0;
    }
    let total = hoursNum;
    if (overtime != null && overtime !== "") {
      const overtimeNum = Number(overtime);
      if (!isNaN(overtimeNum)) {
        total += overtimeNum;
      } else {
        return 0;
      }
    }
    if (total < 0) {
      return 0;
    }
    const hours = Math.floor(total);
    const minutes = Math.floor((total - hours) * 60);
    const seconds = Math.round(((total - hours) * 60 - minutes) * 60);
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}:${String(seconds).padStart(2, "0")}`;
  }

  function calculateEmployeeTotalHours(punchIn, punchOut) {
    const punchInTime = new Date(punchIn);
    const punchOutTime = new Date(punchOut);

    const diffBwPunchInAndPunchOut = punchOutTime - punchInTime;

    if (diffBwPunchInAndPunchOut < 0) return "00:00:00";

    const hours = String(
      Math.floor(diffBwPunchInAndPunchOut / (1000 * 60 * 60))
    ).padStart(2, "0");
    const minutes = String(
      Math.floor((diffBwPunchInAndPunchOut % (1000 * 60 * 60)) / (1000 * 60))
    ).padStart(2, "0");
    const seconds = String(
      Math.floor((diffBwPunchInAndPunchOut % (1000 * 60)) / 1000)
    ).padStart(2, "0");

    return `${hours}:${minutes}:${seconds}`;
  }

  const handleEmployeePresence = async (employee_id, date, presence) => {
    try {
      const company_id = companyID();
      const approved_by = localStorage.getItem("employeeID");
      setLoadingStates((prev) => ({ ...prev, [presence]: true }));
      const response = await api.post(
        `api/attendance/employee_presence?employee_id=${employee_id}&date=${date}&presence=${presence}&company_id=${company_id}&approved_by=${approved_by}`
      );
      setReRenderAttandanceData(true);
      employeeAttendanceHandler(date, employee_id);
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingStates((prev) => ({ ...prev, [presence]: false }));
    }
  };

  const handleClose = () => {
    setEmployeeAttendanceDetail({});
    setActivityDetail([]);
    setReRenderAttandanceData(false);
  };

  return (
    <>
      <div
        className="modal custom-modal fade"
        id="attendance_info"
        role="dialog"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                Attendance Detail of{" "}
                {employeeAttendanceData?.date
                  ? formatDate2(employeeAttendanceData?.date)
                  : ""}
              </h5>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleClose}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body">
              { !isApproveAttendance ? employeeAttendanceDetail?.punch_status != 1 &&
                !isToday(employeeAttendanceData?.date) &&
                employeeAttendanceDetail?.employee_presence != "full_day" && (
                  <div
                    className="mb-2"
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                    }}
                  >
                    <h5
                      style={{
                        color:
                          employeeAttendanceDetail?.marked_full_day_attendance ==
                          1
                            ? "#508D4E"
                            : "var(--company-theme)",
                      }}
                      className="fst-italic"
                    >
                      {employeeAttendanceDetail?.marked_full_day_attendance !=
                        1 && "Mark"}{" "}
                      {employeeAttendanceData?.employeeName}
                      {"'s "}
                      {employeeAttendanceDetail?.marked_full_day_attendance == 1
                        ? `Attendance is Approved`
                        : "Attendance as Present"}
                    </h5>

                    {isDateMatch(employeeAttendanceData?.updated_at) && (
                      <button
                        className="approved-by-reportees"
                        style={{
                          border:
                            employeeAttendanceDetail?.marked_full_day_attendance ===
                            1
                              ? "1.7px solid #e0462b"
                              : "1.7px solid #2aad40",
                          width: "auto",
                          marginLeft: "10px",
                          borderRadius: "10px",
                          color:
                            employeeAttendanceDetail?.marked_full_day_attendance ===
                            1
                              ? "#e0462b"
                              : "#2aad40",
                          backgroundColor: "transparent",
                          fontSize: "12px",
                        }}
                        disabled={loadingStates.approve || loadingStates.revoke}
                        onClick={() =>
                          handleFullAttendanceApproval(
                            formatDate3(employeeAttendanceData.date),
                            employeeAttendanceData?.employeeId,
                            employeeAttendanceData?.employeeName,
                            employeeAttendanceDetail?.marked_full_day_attendance
                          )
                        }
                      >
                        {employeeAttendanceDetail?.marked_full_day_attendance ==
                        1
                          ? loadingStates.revoke
                            ? "Revoking..."
                            : `Revoke`
                          : loadingStates.approve
                          ? "Approving..."
                          : "Approve"}
                      </button>
                    )}
                  </div>
                ):""}

              <div className="row">
                <div className="col-md-6">
                  <div className="card punch-status">
                    <div className="card-body">
                      <div className="punch-det">
                        <h6>Punch In at</h6>
                        <p>
                          {employeeAttendanceData?.date
                            ? formatDateToFullDateString(
                                employeeAttendanceData?.date
                              )
                            : "No Data Found"}{" "}
                          {", "}
                          {employeeAttendanceData?.punchIn
                            ? formatUtcToLocalTime(
                                employeeAttendanceData?.punchIn,
                                "hh:mm:ss A"
                              )
                            : "00:00:00 hrs"}
                        </p>
                      </div>
                      <div className="punch-info">
                        <h6 style={{ textAlign: "center" }}>Total hours</h6>
                        <div className="punch-hours">
                          <span>
                            {employeeAttendanceDetail?.overtime ||
                            employeeAttendanceDetail?.totalHours
                              ? convertToTimeFormat(
                                  employeeAttendanceDetail?.totalHours,
                                  employeeAttendanceDetail?.overtime
                                )
                              : employeeAttendanceData?.punchIn
                              ? calculateTimeDifference(
                                  employeeAttendanceDetail?.punchIn
                                )
                              : "00:00:00"}
                            hrs
                          </span>
                        </div>
                      </div>
                      <div className="punch-det">
                        <h6>Punch Out at</h6>
                        <p>
                          {employeeAttendanceData?.date
                            ? formatDateToFullDateString(
                                employeeAttendanceData?.date
                              )
                            : `No Data Found`}
                          {"  "}
                          {employeeAttendanceData?.punchOut
                            ? formatUtcToLocalTime(
                                employeeAttendanceData?.punchOut,
                                "hh:mm A"
                              )
                            : ` , 00:00:00 hr`}
                        </p>
                      </div>

                      <div className=" punch-det">
                        <h6>
                          Employee Presence :{" "}
                          <span
                            className={` ${
                              employeeAttendanceDetail?.marked_full_day_attendance ==
                                1 ||
                              employeeAttendanceDetail?.employee_presence ==
                                "full_day"
                                ? "text-success"
                                : employeeAttendanceDetail?.employee_presence ==
                                  "half_day"
                                ? "text-warning"
                                : employeeAttendanceDetail?.employee_presence ==
                                  "absent"
                                ? "text-danger"
                                : "-"
                            }`}
                          >
                            {employeeAttendanceDetail?.marked_full_day_attendance ==
                              1 ||
                            employeeAttendanceDetail?.employee_presence ==
                              "full_day"
                              ? "Full Day"
                              : employeeAttendanceDetail?.employee_presence ==
                                "half_day"
                              ? "Half Day"
                              : employeeAttendanceDetail?.employee_presence ==
                                "absent"
                              ? "Absent"
                              : "-"}
                          </span>
                        </h6>
                        <h6>
                          Logout By :{" "}
                          <span
                            className={` ${
                              employeeAttendanceDetail?.logout_by_system == 0
                                ? "text-success"
                                : employeeAttendanceDetail?.logout_by_system ==
                                  1
                                ? "text-danger"
                                : "-"
                            }`}
                          >
                            {employeeAttendanceDetail?.logout_by_system == 0
                              ? "Self"
                              : employeeAttendanceDetail?.logout_by_system == 1
                              ? "System"
                              : "-"}
                          </span>
                        </h6>
                         <h6>
                          Attendance Approval :{" "}
                          <span
                           className={` ${
                              attendanceInfo?.attendance_approval_applied === true
                                ? "text-success" : "text-danger"
                            }`}                          >
                            {attendanceInfo?.attendance_approval_applied === true ? "Applied" : "Not Applied"}
                          </span>
                        </h6> 
                        <h6>
                          Leave Status :{" "}
                          <span
                           className={` ${
                              attendanceInfo?.leave_applied === true
                                ? "text-success" : "text-danger"
                            }`}                          >
                            {attendanceInfo?.leave_applied === true ? "Applied" : "Not Applied"}
                          </span>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card recent-activity">
                    <div className="card-body">
                      <h5 className="card-title">Activity</h5>
                      <ul className="res-activity-list">
                        {activityDetail?.length > 0 ? (
                          activityDetail.map((punch, index) => {
                            return (
                              <li key={index}>
                                <p className="mb-0">
                                  {punch?.activity_type == "Login"
                                    ? "Punch In at"
                                    : "Punch Out at"}{" "}
                                </p>
                                <p className="res-activity-time">
                                  <i className="fa fa-clock-o" />
                                  {getTimeInAMPMFormat(punch.activity_time)}
                                </p>
                              </li>
                            );
                          })
                        ) : (
                          <li> No Activity Found</li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-end">
                { !isApproveAttendance ? employeeAttendanceData?.punchStatus == 1 &&
                  employeeAttendanceDetail?.marked_full_day_attendance == 0 &&
                  !isToday(employeeAttendanceData?.date) &&
                  (employeeAttendanceDetail?.employee_presence ===
                  "full_day" ? (
                    <>
                      <button
                        className="btn btn-danger mx-3"
                        style={{
                          border: "1.7px solid #e0462b",
                          borderRadius: "10px",
                          fontSize: "12px",
                        }}
                        disabled={loadingStates.absent}
                        onClick={() =>
                          handleEmployeePresence(
                            employeeAttendanceData?.employeeId,
                            formatDate3(employeeAttendanceData?.date),
                            "absent"
                          )
                        }
                      >
                        {loadingStates.absent ? "Marking..." : "Mark as Absent"}
                      </button>
                      <button
                        className="btn btn-warning"
                        style={{
                          border: "1.7px solid #ffc107",
                          borderRadius: "10px",
                          fontSize: "12px",
                        }}
                        disabled={loadingStates.halfDay}
                        onClick={() =>
                          handleEmployeePresence(
                            employeeAttendanceData?.employeeId,
                            employeeAttendanceData?.date,
                            "half_day"
                          )
                        }
                      >
                        {loadingStates.halfDay
                          ? "Marking..."
                          : "Mark as Half Day"}
                      </button>
                    </>
                  ) : employeeAttendanceDetail?.employee_presence ===
                    "half_day" ? (
                    <>
                      <button
                        className="btn btn-success mx-3"
                        style={{
                          border: "1.7px solid #2aad40",
                          borderRadius: "10px",
                          fontSize: "12px",
                        }}
                        disabled={loadingStates.fullDay}
                        onClick={() =>
                          handleEmployeePresence(
                            employeeAttendanceData?.employeeId,
                            employeeAttendanceData?.date,
                            "full_day"
                          )
                        }
                      >
                        {loadingStates.fullDay
                          ? "Marking..."
                          : "Mark as Full Day"}
                      </button>
                      <button
                        className="btn btn-danger"
                        style={{
                          border: "1.7px solid #e0462b",
                          borderRadius: "10px",
                          fontSize: "12px",
                        }}
                        disabled={loadingStates.absent}
                        onClick={() =>
                          handleEmployeePresence(
                            employeeAttendanceData?.employeeId,
                            employeeAttendanceData?.date,
                            "absent"
                          )
                        }
                      >
                        {loadingStates.absent ? "Marking..." : "Mark as Absent"}
                      </button>
                    </>
                  ) : (
                    employeeAttendanceDetail?.employee_presence ===
                      "absent" && (
                      <>
                        <button
                          className="btn btn-success mx-3"
                          style={{
                            border: "1.7px solid #2aad40",
                            borderRadius: "10px",
                            fontSize: "12px",
                          }}
                          disabled={loadingStates.fullDay}
                          onClick={() =>
                            handleEmployeePresence(
                              employeeAttendanceData?.employeeId,
                              employeeAttendanceData?.date,
                              "full_day"
                            )
                          }
                        >
                          {loadingStates.fullDay
                            ? "Marking..."
                            : "Mark as Present"}
                        </button>
                        <button
                          className="btn btn-warning"
                          style={{
                            border: "1.7px solid #ffc107",
                            borderRadius: "10px",
                            fontSize: "12px",
                          }}
                          disabled={loadingStates.halfDay}
                          onClick={() =>
                            handleEmployeePresence(
                              employeeAttendanceData?.employeeId,
                              employeeAttendanceData?.date,
                              "half_day"
                            )
                          }
                        >
                          {loadingStates.halfDay
                            ? "Marking..."
                            : "Mark as Half Day"}
                        </button>
                      </>
                    )
                  )) :""}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AttendenceModelPopup;
